
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 4v16h9v-4H4v-1h8v-2H4v-1h8v-2H4V9h11V4H3zm11 3H4V6h10v1z"}}),_c('path',{attrs:{"d":"M13 10v10h8V10h-8zm7 6h-6v-1h6v1zm0-3h-6v-1h6v1z"}})])
          )
        }
      }
    